import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes with proper conflict resolution
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format XP with thousands separator
 */
export function formatXP(xp: number): string {
  return xp.toLocaleString();
}

/**
 * Format coins with thousands separator
 */
export function formatCoins(coins: number): string {
  return coins.toLocaleString();
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
}

/**
 * Get streak emoji based on streak count
 */
export function getStreakEmoji(streak: number): string {
  if (streak >= 10) return '🔥🔥';
  if (streak >= 5) return '🔥';
  if (streak >= 3) return '⚡';
  return '';
}

/**
 * Calculate streak multiplier
 */
export function getStreakMultiplier(streak: number): number {
  if (streak >= 10) return 3;
  if (streak >= 5) return 2;
  return 1;
}
